
import PageLayout from "@/layouts/PageLayout";
import { BackgroundGradient } from "@/components/ui/background-gradient";
import { Helmet } from "react-helmet-async";

const AboutPage = () => {
  // Structured data for About page
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "About cheqbooq",
    "description": "Learn about cheqbooq's mission to revolutionize financial data ownership.",
    "mainEntity": {
      "@type": "Organization",
      "name": "cheqbooq",
      "description": "A financial platform that empowers users with control over their financial data."
    }
  };

  return (
    <PageLayout pageTitle="cheqbooq">
      <Helmet>
        <title>About cheqbooq - Our Story and Mission</title>
        <meta name="description" content="Learn about cheqbooq's mission to revolutionize how people interact with their financial data." />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <BackgroundGradient className="py-16 px-6 flex-grow" variant="subtle">
        <div className="max-w-3xl mx-auto">
          <h1 className="premium-title mb-6">About cheqbooq</h1>
          
          <div className="space-y-6">
            <p className="text-lg">
              We believe that your financial data should work for you, not against you.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-10 mb-4">Our Story</h2>
            <p>
              cheqbooq began with a simple question: Why don't people have control over their own financial data? 
              In a world where financial institutions collect vast amounts of data about your spending habits, income 
              patterns, and financial behaviors, that information is rarely used to benefit you.
            </p>
            <p>
              We saw a fundamental imbalance in the financial world. Financial institutions use your data to maximize their profits while 
              providing minimal value in return. We decided to challenge this status quo.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-10 mb-4">Our Mission</h2>
            <p>
              cheqbooq is not just another financial app – it's a movement to redefine the relationship between people 
              and their financial data. We're building a platform that gives you insights and understanding about your 
              financial life, empowering you to make better decisions about your money.
            </p>
            <p>
              We're committed to transparency, simplicity, and always putting your interests first. We believe that 
              when you understand your financial data, you gain the power to transform your financial future on your own terms.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-10 mb-4">Our Vision</h2>
            <p>
              We envision a world where financial data is democratized – where individuals have as much insight into 
              their financial patterns as the institutions that serve them. Where making informed financial decisions 
              doesn't require a degree in finance or hours spent analyzing spreadsheets.
            </p>
            <p>
              By December 2025, we aim to launch a platform that will provide unprecedented clarity into your financial life, 
              helping you understand patterns, identify opportunities, and make meaningful changes that support your goals.
            </p>
          </div>
        </div>
      </BackgroundGradient>
    </PageLayout>
  );
};

export default AboutPage;
